var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1677 9.84207C20.826 9.5004 20.2344 9.73373 20.2344 10.2087V13.1171C20.2344 14.3337 21.2677 15.3421 22.526 15.3421C23.3177 15.3504 24.4177 15.3504 25.3594 15.3504C25.8344 15.3504 26.0844 14.7921 25.751 14.4587C24.551 13.2504 22.401 11.0754 21.1677 9.84207Z",
    fill: "#D9CDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.082 16.492H22.6737C20.6987 16.492 19.0904 14.8837 19.0904 12.9087V10.5003C19.0904 10.042 18.7154 9.66699 18.257 9.66699H14.7237C12.157 9.66699 10.082 11.3337 10.082 14.3087V21.692C10.082 24.667 12.157 26.3337 14.7237 26.3337H21.2737C23.8404 26.3337 25.9154 24.667 25.9154 21.692V17.3253C25.9154 16.867 25.5404 16.492 25.082 16.492ZM17.582 22.792H14.2487C13.907 22.792 13.6237 22.5087 13.6237 22.167C13.6237 21.8253 13.907 21.542 14.2487 21.542H17.582C17.9237 21.542 18.207 21.8253 18.207 22.167C18.207 22.5087 17.9237 22.792 17.582 22.792ZM19.2487 19.4587H14.2487C13.907 19.4587 13.6237 19.1753 13.6237 18.8337C13.6237 18.492 13.907 18.2087 14.2487 18.2087H19.2487C19.5904 18.2087 19.8737 18.492 19.8737 18.8337C19.8737 19.1753 19.5904 19.4587 19.2487 19.4587Z",
    fill: "#D9CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA7);
export default __webpack_public_path__ + "static/media/a7.09d73e8daa278cce74751831ebafd2bc.svg";
export { ForwardRef as ReactComponent };